/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionChangeRequest
 */
export interface SubscriptionChangeRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionChangeRequest
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionChangeRequest
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionChangeRequest
     */
    referenceSubscriptionId?: string;
}

/**
 * Check if a given object implements the SubscriptionChangeRequest interface.
 */
export function instanceOfSubscriptionChangeRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscriptionChangeRequestFromJSON(json: any): SubscriptionChangeRequest {
    return SubscriptionChangeRequestFromJSONTyped(json, false);
}

export function SubscriptionChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionChangeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'referenceSubscriptionId': !exists(json, 'referenceSubscriptionId') ? undefined : json['referenceSubscriptionId'],
    };
}

export function SubscriptionChangeRequestToJSON(value?: SubscriptionChangeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantity': value.quantity,
        'productId': value.productId,
        'referenceSubscriptionId': value.referenceSubscriptionId,
    };
}

